import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CampaignsRoutingModule } from './campaigns-routing.module';
import { CampaignsComponent } from './campaigns.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { CampaignsFilterComponent } from './campaigns-filter/campaigns-filter.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    CampaignsRoutingModule
  ],
  declarations: [CampaignsComponent, CampaignsFilterComponent],
  entryComponents: [CampaignsFilterComponent]
})
export class CampaignsModule { }
